export default "__VITE_ASSET__DT8Ssj29__"